import { render, staticRenderFns } from "./communityPromotion.vue?vue&type=template&id=7038fb6e&scoped=true"
import script from "./communityPromotion.vue?vue&type=script&lang=js"
export * from "./communityPromotion.vue?vue&type=script&lang=js"
import style0 from "./communityPromotion.vue?vue&type=style&index=0&id=7038fb6e&prod&lang=css"
import style1 from "./communityPromotion.vue?vue&type=style&index=1&id=7038fb6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038fb6e",
  null
  
)

export default component.exports